import { customerApi } from "../../utils/apiConfig";

export const uploadIdariIsler = (userId, file, title, description) => {
  const formData = new FormData();
  formData.append("userId", userId);
  formData.append("title", title);
  formData.append("description", description);
  formData.append("excel", file);

  return customerApi.post("/uploadIdariIslerDocument", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const updateIdariIsler = (updatedId, userId, file, title, description) => {
  const formData = new FormData();
  formData.append("updatedId", updatedId);
  formData.append("userId", userId);
  formData.append("title", title);
  formData.append("description", description);

  if (file) {
    formData.append("excel", file); // dosya seçilmediyse boş göndermiyoruz
  }

  return customerApi.post("/updateIdariIslerDocument", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};


export const getIdariIsler = () => {
  return customerApi.get("/getIdariIslerDocument", {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};
